import React from "react";
import { Bar } from "react-chartjs-2";

// Paleta fija (no aleatoria como randomColors() en DashboardExtraInputs.jsx)
// para que los colores no cambien de un render a otro — se cicla por índice.
const PALETTE = [
  "#3f51b5",
  "#f44336",
  "#4caf50",
  "#ff9800",
  "#9c27b0",
  "#00bcd4",
  "#795548",
  "#607d8b",
];

// Bar agrupado a partir del resultado de pivotEngine.computePivot(). Sin
// colField: una barra por cada valor de fila. Con colField: un grupo de
// barras por valor de fila, una barra por cada valor de columna dentro del
// grupo (ej. rama en el eje X, una barra de color por talla).
export default function PivotResultChart({ result, aggregation }) {
  const { rows, cols, matrix } = result;

  if (!rows.length) return null;

  const esCruzada = cols.length > 0;
  const seriesKeys = esCruzada ? cols : ["_total"];
  const etiquetaSimple = aggregation === "sum" ? "Suma $" : "Cantidad";

  const data = {
    labels: rows,
    datasets: seriesKeys.map((key, idx) => ({
      label: esCruzada ? key : etiquetaSimple,
      data: rows.map((row) => (matrix[row] && matrix[row][key]) || 0),
      backgroundColor: PALETTE[idx % PALETTE.length],
    })),
  };

  return <Bar data={data} />;
}
